import * as bootstrap from "bootstrap"

import {tns} from "tiny-slider/src/tiny-slider.module"

document.addEventListener("DOMContentLoaded", function (event) {
  const sliders = document.getElementsByClassName("slider-container");

  for (let i=0, max=sliders.length; i < max; i++) {
    tns({
      // container: '.logo-slider',
      container: '#' + sliders[i].id,
      items: 5,
      gutter: 15,
      speed: 500,
      nav: false,
      autoplay: true,
      autoplayButtonOutput: false,
      controls: false,
      responsive: {
        0: {
          items: 1,
        },
        780: {
          items: 2,
        },
        960: {
          items: 3,
        },
        1100: {
          items: 4,
        },
      },
    });
  }
})

document.addEventListener("DOMContentLoaded", function (event) {
  let collapseElementList = [].slice.call(document.querySelectorAll('.ce_accordion'))
  let collapseList = collapseElementList.map(function (collapseEl) {

    let toggler = collapseEl.querySelector('.toggler')
    let iconEl = document.createElement('i')
    iconEl.classList.add('fas')
    iconEl.classList.add('fa-fw')
    iconEl.classList.add('fa-plus')
    toggler.prepend(iconEl)

    let content = collapseEl.querySelector('.accordion')
    content.classList.add("collapse");

    let collapseObj = new bootstrap.Collapse(content, {toggle: false})

    toggler.addEventListener('click', function () {
      collapseObj.toggle()
    })

    collapseEl.addEventListener('hidden.bs.collapse', function () {
      iconEl.classList.remove("fa-minus");
      iconEl.classList.add("fa-plus");
    })
    collapseEl.addEventListener('shown.bs.collapse', function () {
      iconEl.classList.remove("fa-plus");
      iconEl.classList.add("fa-minus");
    })

    return collapseObj
  })
})
